import { render, staticRenderFns } from "./PixLogo.vue?vue&type=template&id=c02521d8"
import script from "./PixLogo.vue?vue&type=script&lang=js"
export * from "./PixLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports